module.exports = __webpack_public_path__ + "static/IMG_6794-1500x1125-b87dd2c2f3e8b8ce648672670f905991.jpg";